/**
 *
 * @param index индекс конкретной точки
 * @param active индекс активной точки
 * @param count количество точек
 */
export function getScale(index: number, active: number, count: number): 'M' | 'S' | undefined {
  // активная точка всегда максимального размера
  // если точек 5 и менее, то они все большие
  // в начальном состоянии 3 первые точки крупные OOOo.
  // на конечном экране 3 последние точки крупные .oOOO
  if (
    index === active ||
    count <= 5 ||
    ([0, 1, 2].includes(index) && active < 3) ||
    ([count - 1, count - 2, count - 3].includes(index) && active >= count - 3)
  ) {
    return undefined;
  }

  // точки справа и слева от активной делаем среднего размера
  // на первом экране средней оказывается 4 точка OOOo̱.
  // на последнем экране средней оказывается 4 точка с конца .o̱OOO
  if (
    [active + 1, active - 1].includes(index) ||
    (index === 3 && active < 3) ||
    (index === count - 3 && active >= count - 3)
  ) {
    return 'M';
  }

  // остальные точки всегда маленькие
  return 'S';
}
